import './TableVisualization.css';

export function TableVisualization() {
  return (
    <div className="table-container">
      <div className="table-tennis">
        <div className="table-surface">
          <div className="table-net"></div>
          <div className="table-line table-line--center"></div>
        </div>
        <div className="table-shadow"></div>
      </div>
    </div>
  );
}
